export const datatable = {
  page: 'Page',
  outOf: 'of',
  countSize: 'Records per page',
  showing: 'Showing',
  showingCont: 'records of',
  choose: 'Choose',
  notFoundField: 'Field not found',
  searchPlaceholder: 'Find step',
  resetColumns: 'Reset to defaults',
  saveForAllUsers: 'Save for all',
  saveForAllConfirmTitle: 'Are you sure?',
  saveForAllConfirmDescription:
    'This column configuration will be set as the default for all users.',
  columnsSavedForAll: 'Column settings saved for all users.',
  resetConfirmTitle: 'Are you sure?',
  resetConfirmDescription:
    'Your saved column configuration will be removed and the view will return to its defaults.',
  columnsReset: 'Column settings reset to defaults.',
}
